import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';
const { colors } = theme;

const KNOB_SIZE = 24;

export default createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'block',
      cursor: 'pointer',
      userSelect: 'none',
      width: 44,
      height: 28,
      borderRadius: 28,
      background: colors.backgroundAccent,
      transition: 'background .2s',

      '&:focus': {
        outline: 'none',
      },

      '&:hover': {
        background: colors.backgroundAccentHover,
      },

      '&:active': {
        background: colors.backgroundAccentActive,
      },
    },

    input: {
      display: 'none',
    },

    knob: {
      width: KNOB_SIZE,
      height: KNOB_SIZE,
      borderRadius: '50%',
      background: colors.toggle,
      position: 'absolute',
      top: 2,
      left: 2,
      transition: 'left.2s, background .2s',
    },

    checked: {
      background: colors.backgroundInteractive,

      '&:hover': {
        background: colors.backgroundInteractiveHover,
      },

      '&:active': {
        background: colors.backgroundInteractiveActive,
      },

      '& $knob': {
        left: `calc( 100% - ${KNOB_SIZE}px - 2px)`,
      },
    },

    disabled: {
      cursor: 'default',
      pointerEvents: 'none',
      background: colors.backgroundInteractiveDisabled,

      '& $knob': {
        background: colors.toggleDisabled,
      },
    },
  },
  {
    name: 'Toggle',
  },
);
